import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import NotificationStats from "../../../../containers/NotificationStats";
import NotificationsList from "../../../../containers/NotificationsList";
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import Rbac from '../../../../components/Rbac';
import {withTranslation} from 'react-i18next';
import Api from "../../../../services/Api";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null,
    };
  }

  async componentDidMount() {
    await this.fetchStatus();
  }

  fetchStatus = async () => {
    try {
      const {data} = await Api.invoke('GET', '/v2/admin-ui/notifications/stat', null, {
        params: {
          category: 'DECLARATION',
        },
      });
      this.setState({
        status: data,
      });
    } catch (e) {
      console.log("error: ", e);
    }
  };

  onPressCreate = () => {
    const {history} = this.props;
    history.push('/dashboard/notifications/declaration/create');
  };

  render() {
    const {t, match, history} = this.props;
    const {status} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <div className="mb-4">
                  <NotificationStats data={status}/>
                </div>
                <CardTitle className="text-large text-primary d-flex flex-row justify-content-end align-items-center">
                  <Rbac permission='create_notification'>
                    <Button onClick={this.onPressCreate}>
                      <i className="simple-icon-plus add-reply-icon"/>
                      <span className="mx-1">{t('Send New Notification')}</span>
                    </Button>
                  </Rbac>
                </CardTitle>
                <NotificationsList category="DECLARATION" history={history}/>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
